import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./FlyingStonePage.css";
import { GAME_OPTIONS_PATH } from "../../../../constants";
import flyingstoneBackground from "./flyingstone.jpg";
import { shuffleArray } from "../../../../utils";
import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { useGrammarUnitData, updateProgress } from "../../../../database";

import Score0 from "./resources/Score0.png";
import Score1 from "./resources/Score1.png";
import Score2 from "./resources/Score2.png";
import Score3 from "./resources/Score3.png";
import Score4 from "./resources/Score4.png";
import Score5 from "./resources/Score5.png";
import Score6 from "./resources/Score6.png";
import Score7 from "./resources/Score7.png";
import ScoreWin from "./resources/Score8.png";

const BACKGROUND_IMAGES = [
  Score0,
  Score1,
  Score2,
  Score3,
  Score4,
  Score5,
  Score6,
  Score7,
  ScoreWin,
  ScoreWin,
];

function FlyingStonePage() {
  const EASY_RESPONSE_NUM = 3;
  const MEDIUM_RESPONSE_NUM = 5;
  const HARD_RESPONSE_NUM = 7;
  const location = useLocation();
  const unit = location.state.unit;
  const category = location.state.category;

  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      setUser(user);
    });
  });

  const {
    data: grammarData,
    loading,
    error,
  } = useGrammarUnitData(unit.unit, unit.textbook);

  const [state, setState] = useState({
    questions: [],
    currQuestionIndex: 0,
    score: 0,
    numWrong: 0,
    requiredScore: 0,
    radioButton: null,
    showErrorMessage: false,
    showCorrectMessage: false,
    showSubmit: true,
  });
  const [showTutorial, setShowTutorial] = useState(false);

  useEffect(() => {
    if (grammarData.length > 0) {
      setState((prevState) => {
        if (
          JSON.stringify(prevState.questions) !== JSON.stringify(grammarData)
        ) {
          return {
            ...prevState,
            questions: grammarData,
          };
        }
        return prevState;
      });
    }
  }, [grammarData, loading, state]);

  function startGame() {
    const difficultyRadioButton = document.querySelector(
      'input[name="difficulty"]:checked',
    );

    if (!difficultyRadioButton) {
      alert("Please select a difficulty level before starting the game");
      return;
    }

    const difficulty = difficultyRadioButton.value;

    var requiredScore;

    if (difficulty == "easy") {
      requiredScore = EASY_RESPONSE_NUM;
    } else if (difficulty == "medium") {
      requiredScore = MEDIUM_RESPONSE_NUM;
    } else {
      requiredScore = HARD_RESPONSE_NUM;
    }

    const tutorialEl = document.getElementById("tutorial");
    const settingsEl = document.getElementById("settings-container");
    const gameEl = document.getElementById("game");

    if (tutorialEl) tutorialEl.style.display = "none";
    if (settingsEl) settingsEl.style.display = "none";
    if (gameEl) gameEl.style.display = "flex";

    shuffleArray(grammarData);

    setState((prevState) => ({
      ...prevState,
      currQuestionIndex: 0,
      score: 0,
      numWrong: 0,
      requiredScore: requiredScore,
      radioButton: null,
      showErrorMessage: false,
      showCorrectMessage: false,
    }));

    console.log(`Game Started with Difficulty: ${difficulty}`);
    console.log(`required score: ${state.requiredScore}`);
  }

  const handleOptionChange = (event) => {
    setState({ ...state, radioButton: event.target.value });
  };

  function submitAnswer() {
    const questions = state.questions;
    const currQuestionIndex = state.currQuestionIndex;
    const isTrueFalse =
      questions[currQuestionIndex].choices.length > 0 ? false : true;
    const submissionRadioButton = isTrueFalse
      ? document.querySelector('input[name="true_false"]:checked')
      : document.querySelector('input[name="multi_choice"]:checked');

    // If no answer is selected, alert the user and do not proceed
    if (!submissionRadioButton) {
      alert("Please select an answer before submitting!");
      return;
    }

    // Proceed if an answer is selected
    setState((prevState) => ({ ...prevState, showSubmit: false }));
    const currScore = state.score;
    const submission = submissionRadioButton.value;

    if (submission === questions[currQuestionIndex].answer) {
      console.log(`correct`);

      var newScore = currScore + 1;

      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "flyingstone", true);
      }

      if (newScore === state.requiredScore) {
        const gameEl = document.getElementById("game");
        const postgameEl = document.getElementById("postgame");
        const winTextEl = document.getElementById("win-text");
        const loseTextEl = document.getElementById("lose-text");
        const scoreImageEl = document.getElementById("score-image");

        if (gameEl) gameEl.style.display = "none";
        if (postgameEl) postgameEl.style.display = "flex";
        if (winTextEl) winTextEl.style.display = "flex";
        if (loseTextEl) loseTextEl.style.display = "none";
        if (scoreImageEl) scoreImageEl.setAttribute("src", ScoreWin);

        state.score = 8; // to show the winner animation
      }

      setState((prevState) => ({
        ...prevState,
        score: newScore,
        showCorrectMessage: true,
      }));
    } else {
      const wrong = state.numWrong + 1;
      setState((prevState) => ({
        ...prevState,
        numWrong: prevState.numWrong + 1,
        showErrorMessage: true,
      }));

      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "flyingstone", false);
      }

      if (wrong === 3) {
        const gameEl = document.getElementById("game");
        const postgameEl = document.getElementById("postgame");
        const loseTextEl = document.getElementById("lose-text");
        const winTextEl = document.getElementById("win-text");

        if (gameEl) gameEl.style.display = "none";
        if (postgameEl) postgameEl.style.display = "flex";
        if (loseTextEl) loseTextEl.style.display = "flex";
        if (winTextEl) winTextEl.style.display = "none";
      }
    }

    console.log(`current score: ${state.score}`);
    console.log(`questions wrong: ${state.numWrong}`);

    setTimeout(() => {
      console.log("three second timeout");
      setState((prevState) => ({
        ...prevState,
        radioButton: "",
        currQuestionIndex:
          (prevState.currQuestionIndex + 1) % prevState.questions.length,
        showCorrectMessage: false,
        showErrorMessage: false,
        showSubmit: true,
      }));
    }, 3000);
  }

  function playAgain() {
    setState({
      ...state,
      currQuestionIndex: 0,
      score: 0,
      radioButton: "",
    });

    const settingsEl = document.getElementById("settings-container");
    const tutorialEl = document.getElementById("tutorial");
    const gameEl = document.getElementById("game");
    const postgameEl = document.getElementById("postgame");
    const winTextEl = document.getElementById("win-text");
    const loseTextEl = document.getElementById("lose-text");

    if (settingsEl) settingsEl.style.display = "flex";
    if (tutorialEl) tutorialEl.style.display = "flex";
    if (gameEl) gameEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
    if (winTextEl) winTextEl.style.display = "none";
    if (loseTextEl) loseTextEl.style.display = "none";
  }

  useEffect(() => {
    console.log("Updated Score:", state.score);
  }, [state.score]);

  if (loading) {
    return (
      <div className="loading-screen">
        <h2>Loading grammar questions...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-screen">
        <h2>Error loading grammar questions: {error}</h2>
      </div>
    );
  }

  console.log(state);

  return (
    <div className="flyingstone-full-container">
      <img
        className="background-image"
        src={flyingstoneBackground}
        alt="flying stone"
      />
      <div id="animation-container">
        <img id="score-image" src={BACKGROUND_IMAGES[state.score]} />
      </div>
      <div className="flyingstone-container">
        <div id="flying-stone-page">
          <h1 className="flyingstone-unit-title">{unit.name}</h1>
          {!showTutorial ? (
            <div id="settings-container" className="flyingstone-start-card">
              <button
                type="button"
                className="flyingstone-help-button"
                onClick={() => setShowTutorial(true)}
                aria-label="Open Flying Stone tutorial"
              >
                ?
              </button>
              <h2>Flying Stone Game</h2>
              <div>
                <label>Difficulty Level:</label>
                <input type="radio" id="easy" name="difficulty" value="easy" />
                <label htmlFor="easy">Easy</label>
                <input
                  type="radio"
                  id="medium"
                  name="difficulty"
                  value="medium"
                />
                <label htmlFor="medium">Medium</label>
                <input type="radio" id="hard" name="difficulty" value="hard" />
                <label htmlFor="hard">Hard</label>
              </div>
              <button onClick={startGame}>Start Game</button>
            </div>
          ) : (
            <div className="flyingstone-tutorial-card">
              <h2>Flying Stone Tutorial</h2>
              <p>
                <b>Goal:</b> Knock down the target by answering enough grammar
                questions correctly before you reach 3 mistakes.
              </p>
              <p>
                <b>How to Play:</b>
                <br />
                1. Choose a difficulty level before starting.
                <br />
                2. Read the grammar statement or sentence prompt.
                <br />
                3. Pick either True/False or the best multiple-choice answer.
                <br />
                4. Submit your answer to continue.
              </p>
              <p>
                <b>Rules:</b>
                <br />
                Correct answers increase your score.
                <br />
                Wrong answers count toward your 3 allowed mistakes.
                <br />
                The game ends when you reach the required score or get 3 wrong.
              </p>
              <p>
                <b>Difficulty:</b>
                <br />
                Easy requires 3 correct answers.
                <br />
                Medium requires 5 correct answers.
                <br />
                Hard requires 7 correct answers.
              </p>
              <button
                className="btn btn-primary"
                onClick={() => setShowTutorial(false)}
              >
                Back to Game Setup
              </button>
            </div>
          )}
          <div id="game">
            <div id="score-tracker">
              <h3>Score: {state.score}</h3>
            </div>
            <div id="question">
              {state.questions[state.currQuestionIndex].choices.length === 0 ? (
                <div>
                  <h2>Is the following grammatically true?</h2>
                </div>
              ) : (
                <h2>Choose an option to make it grammatically true</h2>
              )}
              <h2>
                <span id="question-text">
                  {state.questions[state.currQuestionIndex].question}
                </span>
              </h2>
            </div>

            <div>
              {state.questions[state.currQuestionIndex].choices.length === 0 ? (
                <div>
                  <input
                    type="radio"
                    name="true_false"
                    id="true"
                    value="true"
                    checked={state.radioButton === "true"}
                    onChange={handleOptionChange}
                  />
                  <label htmlFor="true">True</label>
                  <input
                    type="radio"
                    name="true_false"
                    id="false"
                    value="false"
                    checked={state.radioButton === "false"}
                    onChange={handleOptionChange}
                  />
                  <label htmlFor="false">False</label>
                </div>
              ) : (
                <div>
                  {state.questions[state.currQuestionIndex].choices.map(
                    (choice, i) => (
                      <React.Fragment key={i}>
                        <input
                          type="radio"
                          name="multi_choice"
                          value={choice.text}
                          id={`choice-${i}`}
                          checked={state.radioButton === choice.text}
                          onChange={handleOptionChange}
                        />
                        <label htmlFor={`choice-${i}`}>{choice.text}</label>
                      </React.Fragment>
                    ),
                  )}
                </div>
              )}
            </div>

            <div id="answer">
              {state.showSubmit && (
                <button className="btn btn-primary" onClick={submitAnswer}>
                  Submit
                </button>
              )}
            </div>

            {state.showErrorMessage && (
              <div id="error">
                <h2 id="error-message">Incorrect answer!</h2>
                <h3 id="error-message">
                  The right answer is :{" "}
                  {state.questions[state.currQuestionIndex].answer}
                </h3>
              </div>
            )}
            {state.showCorrectMessage && (
              <div id="correct">
                <h2 id="correct-message">Correct answer! Good job!</h2>
              </div>
            )}
          </div>
          <div id="postgame">
            <h2 id="win-text">Congratulations, you win!</h2>
            <h2 id="lose-text">Sorry, you lose. Better luck next time!</h2>
            <button className="btn btn-primary" onClick={playAgain}>
              Play Again
            </button>
          </div>
        </div>
        <Link
          to={GAME_OPTIONS_PATH}
          state={{ unit: unit, category: category }}
          className="game-options-back-link"
        >
          <button className="btn btn-back game-options-back-button">{"Back"}</button>
        </Link>
      </div>
    </div>
  );
}

export default FlyingStonePage;
